/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import product from "../../http/requests/product";
import Helpers from "../../utils/helpers";

export default {
	fetchShippings({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getListShippings(payload)
					.then((response) => {
						commit("SET_SHIPPINGS", response.data.data.data);
						commit("SET_SHIPPINGS_TOTAL", response.data.data.total);
						
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},

	fetchSos({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getSos(payload)
					.then((response) => {
						commit("SET_SHIPPINGS", response.data.data.data);
						commit("SET_SHIPPINGS_TOTAL", response.data.data.total);
						
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getPaymentNos({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getPaymentNos(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getMatchingSells({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getMatchingSells(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getMatching({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getMatching(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashboardSellList({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashboardSellList(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashbboardSuggest({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashbboardSuggest(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashboardOrder({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashboardOrder(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashboardBuyList({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashboardBuyList(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashboardMatching({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashboardMatching(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashboardNewOrder({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashboardNewOrder(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDashboardPriceHistories({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDashboardPriceHistories(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getOverviewOrder({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getOverviewOrder(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getProvinces({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getProvinces(payload)
					.then((response) => {
						resolve(response.data.data);
						commit("SET_PROVINCES", response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getDistricts({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getDistricts(payload)
					.then((response) => {
						resolve(response.data.data);
						// commit("SET_PROVINCES", response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getShipping({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getShipping(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},

	getShippingBackdoor({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getShipping(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						// Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	fetchMatchings({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getListMatchings(payload)
					.then((response) => {
						commit("SET_MATCHINGS", response.data.data.data);
						commit("SET_MATCHINGS_TOTAL", response.data.data.total);
						
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	saveShipping({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.saveShipping(payload)
					.then((response) => {
						if (response.data.status) {
							resolve(response.data.data);
						} else {
							reject(response.data.error);
						}
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	confirmBuy({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.confirmBuy(payload)
					.then((response) => {
						resolve(response.data);
						// if (response.data.status) {
						// 	resolve(response.data.data);
						// } else {
						// 	reject(response.data.error);
						// }
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	doneShipping({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.doneShipping(payload)
					.then((response) => {
						if (response.data.status) {
							resolve(response.data.data);
						} else {
							reject(response.data.error);
						}
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},

	saveSo({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.saveSo(payload)
					.then((response) => {
						if (response && response.data) {
							if (response.data.status) {
								resolve(response.data.data);
							} else {
								reject(response.data.error);
							}
						} else {
							reject('Unexpected err');
						}
					})
					.catch((error) => {
						alert(error.message);
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},

	kcsReviewShipping({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.kcsReviewShipping(payload)
					.then((response) => {
						if (response && response.data) {
							if (response.data.status) {
								resolve(response.data.data);
							} else {
								reject(response.data.error);
							}
						} else {
							reject('Unexpected err');
						}
					})
					.catch((error) => {
						alert(error.message);
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	setPaymentInfo({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.setPaymentInfo(payload)
					.then((response) => {
						if (response.data.status) {
							resolve(response.data.data);
						} else {
							reject(response.data.error);
						}
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	setPaymentInfoAqua({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.setPaymentInfoAqua(payload)
					.then((response) => {
						if (response.data.status) {
							resolve(response.data.data);
						} else {
							reject(response.data.error);
						}
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	ratingBuyer({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.ratingBuyer(payload)
					.then((response) => {
						if (response.data.status) {
							resolve(response.data.data);
						} else {
							reject(response.data.error);
						}
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	fetchProducts({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getListProducts(payload)
					.then((response) => {
						commit("SET_PRODUCTS", response.data.data);
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	fetchSuppliers({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getListSuppliers(payload)
					.then((response) => {
						// console.log(resolve);
						// commit("SET_SUPPLIERS", [{id: 0, name: 'Khác'}].concat(response.data.data));
						commit("SET_SUPPLIERS", response.data.data);
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getShippingFileById({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getShippingFileById(payload)
					.then((response) => {
						// commit("SET_PRODUCTS", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getOrdersByProduct({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getOrdersByProduct(payload)
					.then((response) => {
						// commit("SET_PRODUCTS", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getPlaces({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getPlaces(payload)
					.then((response) => {
						commit("SET_PLACES", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getOrdersByMe({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getOrdersByMe(payload)
					.then((response) => {
						// console.log(response);
						commit("SET_MYORDERS", response.data.data.data);
						commit("SET_MYORDERS_TOTAL", response.data.data.total);
						
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getShippingsByPmid({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getShippingsByPmid(payload)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getOrderById({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getOrderById(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getPoById({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getPoById(payload)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	getSellsList({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.getSellsList(payload)
					.then((response) => {
						commit("SET_SELLS", response.data.data.data);
						commit("SET_SELLS_TOTAL", response.data.data.total);
						
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	createOrder({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.createOrder(payload)
					.then((response) => {
						// commit("SET_PRODUCTS", response.data.data);
						if (response && response.data && response.data.data) {
							resolve(response.data.data);
						} else {
							reject({message: response.data.error});
						}
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
	cancelOrder({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				product
					.cancelOrder(payload)
					.then((response) => {
						// commit("SET_PRODUCTS", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
						Helpers.checkToken(error);
					});
			});
		} catch (error) {
			console.error("[fetchProducts]", error);
		}
	},
};
